import React from "react";
/*import { FaPhone, FaMapMarkerAlt, FaCopyright, FaSmileBeam } from "react-icons/fa";*/
import { FaCopyright} from "react-icons/fa";
import "../assets/styles/Footer.css"; // Import optimized CSS
/*import CompleteLogo from '../assets/images/CompleteLogo.png';*/

const Footer = () => {
  return (
    <footer>
      {/* Left Section: Logo & Description 
      <div className="footer-container">
        
        <div className="footer-left">
          <a href="https://chaperoneai.net" target="_blank" rel="noopener noreferrer">
            <img src={CompleteLogo} alt="logo" width="80%"/>
          </a>
          <p>Generative AI for Business Solutions.</p>
        </div>

        <div className="footer-contact">
          <h4>ADDRESS</h4>
          <p>
            <FaPhone style={{ color: "grey" }}/> &nbsp; +43-1-2396082 <br />
            <FaMapMarkerAlt style={{ color: "grey" }}/> &nbsp; 1030 Vienna, Austria <br />
            <FaSmileBeam style={{ color: "#f1c40f" }} /> 
            
            <a
              href="https://empirischtech.at"
              target="_blank"
               rel="noreferrer"
              style={{
                textDecoration: "none",
                color: "gray", // Default color
              }}
              onMouseEnter={(e) => (e.target.style.color = "#f1c40f")} // Hover color
              onMouseLeave={(e) => (e.target.style.color = "gray")} // Back to normal color
            >
              &nbsp; &nbsp;  empirischtech.at
              </a>
          </p>
        </div>
      </div>
        */}
      {/* Divider */}
      <hr className="footer-divider" />

      {/* Footer Bottom Section */}
      <div className="footer-container">
        <div className="footer-bottom">
          <p>
            <FaCopyright />&thinsp; 2021 Empirisch Tech
          </p>
        </div>
        <div className="footer-right">
          <ul>
            <li><a href="privacy-policy" >DATA PRIVACY</a></li>
            <li><a href="privacy-policy-de" >DATENSCHUTZ</a></li>
            <li><a href="/terms-of-use" >TERMS OF USE</a></li>
            <li><a href="/impressum" >IMPRESSUM</a></li>
          </ul>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
